export default (function (x) {
  return typeof x === 'string' ? x : x.reduce(function (acc, transform) {
    var key = Object.keys(transform)[0];

    switch (key) {
      case 'translateY':
        return acc + ' translateY(' + transform[key] + 'px)';

      case 'translateX':
        return acc + ' translateX(' + transform[key] + 'px)';

      default:
        return acc;
    }
  }, '');
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/@primitives/layout/build/web/styleTransformArrayToText.js
// module id = 468
// module chunks = 0